import { styled } from "__barrel_optimize__?names=styled!=!@mui/material";
export const appStyled = (component)=>styled(component, {
        shouldForwardProp: (prop)=>!prop.startsWith("$") && prop !== "isMobileWithFooter"
    });
